import { FC } from 'react'
import styles from './lang-controller.module.scss'
import { useRouter } from 'next/router'
import ICustomRouterQuery from '@/types/custom-router-query.interface'
import { ALL_LANGUAGES, DEFAULT_LANGUAGE } from '@/locales/i18n'
import classNames from '@/utils/helpers/class-names.helper'
import useI18nPath from '@/hooks/i18n-path.hook'

type LangControllerProps = {
  className?: string
}

const LangController: FC<LangControllerProps> = ({ className }) => {
  const router = useRouter()
  const { lang } = router.query as ICustomRouterQuery

  const toggleLanguage = () => {
    const nextLang = lang === ALL_LANGUAGES[1] ? ALL_LANGUAGES[0] : ALL_LANGUAGES[1]

    if (nextLang === DEFAULT_LANGUAGE) {
      delete router.query.lang
      router.push(
        {
          pathname: router.pathname.replace('/[lang]', '') || '/',
          query: { ...router.query },
        },
        undefined,
        { scroll: false }
      )
    } else {
      router.push(
        {
          pathname: `/[lang]/${router.pathname}`,
          query: { ...router.query, lang: nextLang },
        },
        undefined,
        { scroll: false }
      )
    }
  }

  return (
    <>
      <div className={classNames(styles.language, className)} onClick={toggleLanguage}>
        <div className={styles.language__icon}>
          <svg
            width="28"
            height="28"
            viewBox="0 0 28 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_96_440)">
              <path
                d="M14 27C21.1797 27 27 21.1797 27 14C27 6.82029 21.1797 1 14 1M14 27C6.82029 27 1 21.1797 1 14C1 6.82029 6.82029 1 14 1M14 27C17.023 27 19.4737 21.1797 19.4737 14C19.4737 6.82029 17.023 1 14 1M14 27C10.977 27 8.52632 21.1797 8.52632 14C8.52632 6.82029 10.977 1 14 1M1.68421 9.89474H26.3158M1.68421 18.1053H26.3158"
                stroke="#2B2F33"
                strokeWidth="1.25"
                strokeLinecap="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_96_440">
                <rect width="28" height="28" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>
        <div className={styles.language__body} onClick={toggleLanguage}>
          <p className={styles.language__text}>{lang ? 'RU' : 'EN'}</p>
        </div>
      </div>
    </>
  )
}

export default LangController
